import {Container, Singleton} from "typescript-ioc";
import Company from "@/model/Company";
import StorageKey from "@/storage/StorageKey";
import BizStorage from './BizStorage';
import {LocalStorageWrapper} from "@/storage/StorageWrapper";

@Singleton
export default abstract class CompanyStorage extends BizStorage<Company> {
    protected key = StorageKey.COMPANY
}

class CompanyStorageImpl extends CompanyStorage {
    storage = Container.get(LocalStorageWrapper)
}

Container.bind(CompanyStorage).to(CompanyStorageImpl)
